import { 
  GET_NOTCH_IMPACT_TEST_FAILURE, 
  GET_NOTCH_IMPACT_TEST_REQUEST, 
  GET_NOTCH_IMPACT_TEST_SUCCESS 
} from "./notchImpactTestTypes";

const initialState = {
  loading: false,
  notchImpactTest: [],
  error: "",
};

const getNotchImpactTestReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTCH_IMPACT_TEST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_NOTCH_IMPACT_TEST_SUCCESS:
      return {
        loading: false,
        notchImpactTest: action.payload,
        error: "",
      };
    case GET_NOTCH_IMPACT_TEST_FAILURE:
      return {
        loading: false,
        notchImpactTest: [],
        error: action.payload,
      };
    default:
      return state; 
  }
};

export { getNotchImpactTestReducer };